import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { service_url } from "./service-url";

@Injectable({
  providedIn: 'root'
})
export class CarerPatientService {
  api_url: any
  constructor(private http: HttpClient) {
    this.api_url = service_url.api_url
  }

  getCarerPatients(filters = {}) {
    let params = new HttpParams();
    Object.keys(filters).forEach(function (key) {
      params = params.append(key, filters[key]);
    });
    return this.http.get(this.api_url + '/carer_patients', { params: params })
  }

  showCarerPatient(carer_patient_id) {
    return this.http.get(this.api_url + '/carer_patients/' + carer_patient_id)
  }

  submitCarerPatient(params, id = '') {
    if (id != '') {
      return this.http.put(this.api_url + '/carer_patients/' + id, { carer_patient: params })
    }
    else {
      return this.http.post(this.api_url + '/carer_patients', { carer_patient: params })
    }
  }

  deleteCarerPatient(carer_patient_id) {
    return this.http.delete(this.api_url + '/carer_patients/' + carer_patient_id)
  }
}
